
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
import { LanguageModel } from 'models/generated/Language.Api.Models.Language';


const _language_LanguageControllerHelper = new Map<string, Object>();
_language_LanguageControllerHelper.set('GetLanguages', LanguageModel);
_language_LanguageControllerHelper.set('GetLanguage', LanguageModel);
_language_LanguageControllerHelper.set('CreateLanguage', LanguageModel);


export const language_LanguageControllerHelper = _language_LanguageControllerHelper;

